import type { CharacterLimit } from '~/universal/types';

export const LIMIT_OF_CHARACTERS = {
  META_KEY_WORDS: {
    MIN: 4,
    MAX: 250,
  },
  ALIAS: {
    MIN: 4,
    MAX: 50,
  },
  MESSAGE: {
    MIN: 1,
    MAX: 5000,
  },
  FILE_NAME: {
    MIN: 4,
    MAX: 40,
  },
  LINK_NAME: {
    MIN: 4,
    MAX: 200,
  },
  HTML_TEXT: {
    MIN: 1,
    MAX: 15000,
  },
  HOME_TASK: {
    MIN: 1,
    MAX: 5000,
  },
  PHONE_NUMBER: {
    MIN: 6,
    MAX: 15,
  },
  FIRST_NAME: {
    MIN: 1,
    MAX: 50,
  },
  LAST_NAME: {
    MIN: 1,
    MAX: 50,
  },
  LOGIN: {
    MIN: 3,
    MAX: 100,
  },
  PASSWORD: {
    MIN: 4,
    MAX: 30,
  },
  USER_NAME: {
    MIN: 4,
    MAX: 100,
  },
  EMAIL: {
    MIN: 4,
    MAX: 100,
  },
  CONTENT: {
    MIN: 300,
    MAX: 50000,
  },
  AGE: {
    MIN: 0,
    MAX: 120,
  },
  META_DESCRIPTION: {
    MIN: 20,
    MAX: 160,
  },
  DESCRIPTION: {
    MIN: 20,
    MAX: 160,
  },
  META_TITLE: {
    MIN: 4,
    MAX: 80,
  },
  TITLE: {
    MIN: 4,
    MAX: 80,
  },
  LESSON_TEMPLATE_TITLE: {
    MIN: 4,
    MAX: 140,
  },
} as const satisfies Readonly<Record<string, CharacterLimit>>;
